
import { defineComponent, toRefs, computed } from "vue";
import { ImagePreview } from "vant";

export default defineComponent({
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const { detail } = toRefs(props);
    const pageData = computed(() => {
      return detail;
    });

    const clickImage = (url: string) => ImagePreview({ images: [url] });
    return {
      pageData,
      clickImage
    };
  }
});
